import { AbstractControl, FormGroup, FormArray } from '@angular/forms';
import { SchemasService } from './schemas.service';

export class ValidationContext {

	protected controll: AbstractControl;
	protected debugg = false;

	constructor(
		protected control: AbstractControl,
		protected schemasService: SchemasService,
		protected debug?: boolean
	) {
		this.controll = control;
		this.debugg = debug;
	}

	/**
	 * t
	 * @param path
	 */
	public FindRootValue(path: string): any {
		path = path.replace('InspectionReport.', '');
		path = path.split('.').join('..');
		return this.schemasService.query((this.controll.root as FormGroup).getRawValue(), path).shift();
	}

	/**
	 * tt
	 * @param path
	 */
	public FindRootValues(path: string): any {
		path = path.replace('InspectionReport.', '');
		path = path.split('.').join('..');
		return this.schemasService.query((this.controll.root as FormGroup).getRawValue(), path);
	}

	/**
	 * t
	 * @param path
	 */
	public FindValue(path: string): any {
		let parent;
		if (this.controll.parent) {
			parent = (this.controll.parent as FormGroup).getRawValue();
		} else {
			parent = (this.controll.root as FormGroup).getRawValue();
		}
		const jpQuery = this.schemasService.query(parent, path).shift();
		// if (this.debug) {
		// 	console.log(parent, path, this.controll.value, jpQuery);
		// }

		return jpQuery;
	}

	/**
	 * t
	 * @param path
	 */
	public FindValues(path: string): any {
		if (path.indexOf('.') === -1) {
			return this.FindValue(path);
		} else {
			path = path.split('.').join('..');
			return this.schemasService.query(
				this.controll.parent ?
					(this.controll.parent as FormGroup).getRawValue() :
					(this.controll.root as FormGroup).getRawValue(),
				path
			);
		}
	}

	/**
	 * t
	 */
	public GetValue(): any {
		return this.controll.value;
	}

	/**
	 * t
	 */
	public IsEmpty(): any {
		const value = this.controll.value;
		const isFormGroup = this.controll instanceof FormGroup;
		const isFormArray = this.controll instanceof FormArray;

		if (isFormArray) {
			return value.length === 0;
		} else {
			if (isFormGroup) {
				return Object.keys(value).length === 0;
			} else {
				return (value === '' || value === null);
			}
		}
		// return isFormArray ? value.length === 0 : (isFormGroup ? Object.keys(value).length === 0 : (value === '' || value === null));
	}

	/**
	 * t
	 * @param path
	 */
	public FindChildValue(path: string): any {
		const pPath = path.replace(/(\[[a-zA-Z=']+\])/g, '[*]');
		return this.schemasService.query(
			(this.controll as FormArray).getRawValue(),
			pPath
		).shift();
	}

	/**
	 * t
	 * @param path
	 */
	public FindChildValues(path: string): any {
		const pPath = path.replace(/(\[[a-zA-Z=']+\])/g, '[*]');
		return this.schemasService.query(
			(this.controll as FormArray).getRawValue(),
			`$..${pPath}`
		);
	}

	/**
	 * t
	 * @param path
	 */
	public FindSiblingValues(path: string): any {
		const pPath = path.replace(/(\[[a-zA-Z=']+\])/g, '[*]');
		return this.schemasService.query(
			(this.controll.parent.parent as FormArray).getRawValue(),
			`$..${pPath}`
		);
	}

}
